import { render } from "./AppSpacer.vue?vue&type=template&id=442f89da"
import script from "./AppSpacer.vue?vue&type=script&lang=js"
export * from "./AppSpacer.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__